import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NetworkCallService } from '../../../core/services/network-call.service';
import { Router } from '@angular/router';
import { catchError, map, switchMap } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';

import { concat, of } from 'rxjs';
import * as resendOtp from '../actions/resend-otp.actions';
import { IResendOTPRequest, IResendOtpRequest, IResendOTPResponse, IResendOtpResponse } from '../../../core/models/otp-resend.model';
import { HelpersService } from '../../../core/services/helpers.service';
import notify from 'devextreme/ui/notify';
import { SharedService } from '../../../shared/shared.service';

@Injectable()
export class ResendOtpEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private helperService: HelpersService,
    private sharedService: SharedService
  ) {}

  resendOtp$ = createEffect(() =>
    this.actions$.pipe(
      ofType(resendOtp.loadResendOtpRequest),
      switchMap(action =>
        this.networkCallService.post<IResendOtpRequest, IResendOtpResponse>('Authentication/resendOtp', action.request).pipe(
          map(response => {
            if (response.success) {
              this.helperService.notifySuccess(`Woosh! Your new OTP is on the way`, 300, 3000);
            } else if (!response.success) {
              this.helperService.notifyError(`There was an error sending your new OTP. Please contact support.`, 400, 3000);
            }
            return resendOtp.loadResendOtpsSuccess({ response });
          }),
          retryTransientHttpErrors(),
          catchError(error => {
            return of(resendOtp.loadResendOtpsFailure(error));
          })
        )
      )
    )
  );

  resendNewOtp$ = createEffect(() =>
    this.actions$.pipe(
      ofType(resendOtp.resendOtpRequest),
      switchMap(action =>
        this.networkCallService.post<IResendOTPRequest, IResendOTPResponse>('Authentication/businessForgotPasscodeResendOtp', action.request).pipe(
          map(response => {
            if (response.success) {
              this.sharedService.forgotPasscodeIsOTP = true;
              this.helperService.notifySuccess(` Woosh! Your new OTP is on the way`, 300, 3000);
            } else if (!response.success) {
              this.helperService.notifyError(`There was an error sending your new OTP. Please contact support.`, 400, 3000);
              this.sharedService.forgotPasscodeIsOTP = false;
            }
            return resendOtp.resendOtpSuccess({ response });
          }),
          catchError(error => {
            this.sharedService.forgotPasscodeIsOTP = false;
            return of(resendOtp.resendOtpFailure(error));
          })
        )
      )
    )
  );
}
